import { useSizeGuide } from "./use-size-guide";
import { SizeGuideHeading } from "./size-guide-heading";
import { MeasurementStep } from "./measurement-step";
import { SizeGuideTableWrapper } from "./size-guide-table-wrapper";
import { SizeGuideFooter } from "./size-guide-footer";
import { useTranslate } from "@made-people/grease-translations";

export const CamisoleCharts = () => {
  const sizeGuide = useSizeGuide();
  const translate = useTranslate();
  if (!sizeGuide) return null;

  if (!sizeGuide.brasBandTable || !sizeGuide.brasCupTable) {
    return null;
  }

  return (
    <>
      <SizeGuideHeading
        title={translate("Size_Guide_Camisoles_And_Tops_Title")}
      >
        <MeasurementStep
          number={1}
          text={translate("Size_Guide_How_To_Measure_Step_1")}
        />
        <MeasurementStep
          number={2}
          text={translate("Size_Guide_How_To_Measure_Step_2")}
        />
        <MeasurementStep
          number={3}
          text={translate("Size_Guide_How_To_Measure_Step_3")}
        />
      </SizeGuideHeading>

      <SizeGuideTableWrapper
        tableData={sizeGuide.brasBandTable}
        icon={sizeGuide.bandTableIcon}
        title={translate("Size_Guide_Band_Size_Title")}
      />

      <SizeGuideTableWrapper
        tableData={sizeGuide.brasCupTable}
        icon={sizeGuide.cupTableIcon}
        title={translate("Size_Guide_Cup_Size_Title")}
      />

      {sizeGuide.swimBottomUpdatedTable && (
        <SizeGuideTableWrapper tableData={sizeGuide.swimBottomUpdatedTable} />
      )}

      <SizeGuideFooter className="text-body-sm" />
    </>
  );
};
